import React, { Component } from "react";

class Home extends Component {
  render() {
    return (
      <div className="container_ab">
        <h1
          style={{
            fontSize: "40px",
            textAlign: "center",
            color: "#333",
            paddingTop: "30px",
          }}
        >
          Welcome to System Manager!
        </h1>
      </div>
    );
  }
}
// const Home = () => (
//   <div className="container_ab">
//     <h1 style={{fontSize: '40px',textAlign: 'center',color: '#333', paddingTop: '30px'}}>Welcome to System Manager!</h1>
//   </div>
// );

export default Home;
